export enum LockValue {
  LOCKED = 1,
  UNLOCKED = 0,
}

export class LockMap {
  private readonly lockMap = new Map<string, LockValue>();
  public isLocked(lockId: string): LockValue {
    if (!this.lockMap.has(lockId)) {
      return LockValue.UNLOCKED;
    }
    return this.lockMap.get(lockId);
  }

  lock(lockId: string): void {
    this.lockMap.set(lockId, LockValue.LOCKED);
  }

  unlock(lockId: string): void {
    this.lockMap.set(lockId, LockValue.UNLOCKED);
  }
}
